import axios from 'axios';

// const API_BASE_URL = 'https://connexis.ro/api/dictionary';
const API_BASE_URL = '/api/dictionary';

export const fetchContent = async () => {
  try {
    const response = await axios.get(API_BASE_URL);
    return response.data;
  } catch (error) {
    console.error('Error fetching content:', error);
    throw error;
  }
};